<template>
  <div>
    <input :type="type"
       :name="keyIndex"
       class="input-box"
       :class="{ error: isError }"
       :style="{ width }"
       v-bind:value="value"
       v-on:input="updateValue($event.target.value)"
       @focus="onFocus"
       @blur="onBlur"
       :placeholder="placeHolder" :disabled="isDisabled" step="any"/>
    <div v-if="hint != null && hint.length > 0">{{hint}}</div>
  </div>
</template>

<script>
import _ from 'lodash';

export default {
  props: {
    keyIndex: {
      type: String,
    },
    type: {
      default: 'text',
    },
    value: {
      type: [String, Number],
    },
    placeHolder: {
      type: String,
    },
    hint: {
      type: String,
    },
    width: {
      type: String,
      default: '',
    },
    regex: {
      type: String,
      default: '',
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
    onFocus: {
      type: Function,
      default: () => {},
    },
    onBlur: {
      type: Function,
      default: () => {},
    },
    isFloat: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isError() {
      if (_.isEmpty(this.regex)) return false;

      const result = new RegExp(this.regex);
      return !result.test(String(this.value).toLowerCase());
    },
  },
  methods: {
    updateValue(value) {
      if (this.isFloat) {
        this.$emit('input', parseFloat(value));
      } else {
        this.$emit('input', this.type === 'number' ? parseInt(value, 10) : value);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
input {
  margin: 5px 0 5px 0;
  &:disabled {
    background-color: rgb(200,200,200);
  }
}

.input-box {
  width: 500px;
  height: 40px;
  padding-left: 15px;
  outline: none;

  border: rgba(180, 180, 180, 0.4) 1px solid;

  border-radius: 5px;
}

.input-box:hover {
  border: rgba(180, 180, 180, 0.8) 1px solid;
}

.input-box:focus {
  border: rgba(100, 200, 255, 0.8) 1px solid;
  box-shadow: rgba(0, 0, 0, 0.1) 1px 1px 5px 1px;
}
.error {
  color: rgb(159, 85, 80);
  background: rgb(253, 246, 246);
  border: rgb(217, 162, 181) 1px solid;
}
</style>



// WEBPACK FOOTER //
// src/spa/components/LayoutInput.vue